
import Component from '@modules/vue-class-component';
import Container from '../container/container.vue';
import Vue from 'vue';
import CircleIcon from '../container/circleIcon.vue';
import { Prop } from '@modules/vue-property-decorator';
import { DateHelper } from '@shared/core/helpers/dateHelper';
import { Settings } from '@shared/core/services/configService';
import { CrudService } from '@shared/core/services/crudService';
import { Booking } from '@shared/core/interfaces/booking';
import store from "@shared/core/store";


@Component({
  components: {
    Container,
    CircleIcon,
  },
})
export default class BookingSummary extends Vue {
  @Prop() booking!: Booking;
  @Prop({ default: true }) showIcons!: boolean;

  private get summary(): {label: string, icon: string, text: string}[] {
    if (!this.booking) {
      return [];
    }
    const levelStr = this.booking.minLevel != null && this.booking.maxLevel != null
            ? `${this.booking.minLevel} - ${this.booking.maxLevel}`
            : null;
    return [
      {
        label: this.$t('Date'),
        icon: this.isDarkMode ? require('@/images/calendar-icon.svg') : require('@/images/calendar-black-icon.svg'),
        text: DateHelper.beautifyDate(this.booking.date, true, true, false, false),
      },
      {
        label: this.$t('Time'),
        icon: this.isDarkMode ? require('@/images/clock-icon.svg') : require('@/images/clock-black-icon.svg'),
        text: `${DateHelper.extractTime(this.booking.date)} - ${this.booking.duration} ${this.$t("mins")}`,
      },
      {
        label: this.$t('Level'),
        icon: this.isDarkMode ? require('@/images/booking-level-white-icon.svg') : require('@/images/booking-level-black-icon.svg'),
        text: this.booking.modifyLevel
          ? `${levelStr ? levelStr + ' | ' : ''}${this.$t("Competitive")}`
          : this.$t("Friendly"),
      },
      {
        label: this.$t('Resource'),
        icon: this.isDarkMode ? require('@/images/court-white-icon.svg') : require('@/images/court-black-icon.svg'),
        text: `${this.booking.resources}`,
      },
      {
        label: this.$t('Cancels'),
        icon: this.isDarkMode ? require('@/images/cancel-white-icon.svg') : require('@/images/cancel-black-icon.svg'),
        text: `${this.booking.cancelText}`,
      },
    ];
  };


  private get isDarkMode() {
    return store.state.settings.DarkMode === true;
  }

  private resourceImg: string|null = null;
  async mounted() {
    const url = `${Settings.HostName}/api/czconfigs/template`;
    const data = await new CrudService().httpGet(url);
    if (data == null || data.data == null || !data.ok) {
      console.error("Crash getting cz template settings");
      return;
    }
    this.resourceImg = this.$store.state.settings.Uploads + "/" + data.data.image1;
  }

}

